import { useEffect, useState } from "react";
import { PrivacyDialogAuto } from "./PrivacyDialogAuto";
import { autoJsStoreUtils } from "@droid/android";
import { IDispatcher } from "@fanfanlo";


export function ListenShowPrivacyContent({type, dispatcher}:{type:string, dispatcher?:IDispatcher}){
    return(
        <PrivacyDialogAuto type={type} area="zh-cn" dispatcher={dispatcher} />
    )
}